module.exports = "https://img.xiyuyouxi.com/saas/img/arrow_down.fdfe00b4.png";